@if (show) {
  <div class="cb-choices-wrapper">
    <div class="cb-choice-overlay" (click)="selectChoice(null)"></div>
    <div class="cb-choices-container">
      <ul class="cb-choice-list" [class.cb-animated-choices]="animate">
        <li (click)="selectChoice(null)">
          <cb-icon name="cb cb-base-outline-close"></cb-icon>
          <p>{{ "COMMON.CANCEL" | translate }}</p>
        </li>
        @if (choices.length == 0) {
          <li class="cb-empty-choices" (click)="selectChoice(null)">
            <p>{{ "COMMON.NO_CHOICES_AVAILABLE" | translate }}</p>
          </li>
        }
        @for (choice of choices; track choicesTrackBy($index, choice)) {
          <li
            [class.selected]="isSelected(choice)"
            (click)="selectChoice(choice.value)"
            [ngClass]="['cb-choice-' + choice.color]"
            >
            @if (choice.icon) {
              <cb-icon [name]="choice.icon"></cb-icon>
            }
            <p>{{ choice.label | translate: choice.labelOptions ?? {} }}</p>
            @if (isMultiple) {
              <cb-icon
            [name]="
              isSelected(choice)
                ? 'cb cb-base-bold-checkmark-circle'
                : 'cb cb-base-bold-close-circle'
            "
              ></cb-icon>
            }
          </li>
        }
      </ul>
    </div>
  </div>
}
